import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Modal, ButtonToolbar } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  getValueType,
  showDialog,
  showErrorDialog,
  sizePerPageList,
  useForceUpdate,
  useStyles,
  useStylesReddit,
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import SVG from "react-inlinesvg";
import Select from "react-select";
import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
} from "../../../_metronic/_helpers";
import {
  selectPagination,
  selectUser,
} from "../../modules/Auth/_redux/authRedux";
import paginationFactory from "react-bootstrap-table2-paginator";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";

// MUI
import {
  fade,
  withStyles,
  makeStyles,
  createMuiTheme,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import {
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  selectClient,
  fetchClient,
} from "../client/clientSlice";

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

export const ModalClientRadio = ({
  isOpen,
  setShow,
  formValues,
  setFormValues,
  setFields,
  fields,
  getData,
  setGetData,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const data = useSelector(selectClient);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const [tableData, setTableData] = useState(data);
  const paginationSet = useSelector(selectPagination);

  const [selected, setSelected] = useState(null);

  useEffect(() => {
    if (getData === true) {
      handleSearch();

      setGetData(false);
    }
  }, [getData]);

  // initial

  useEffect(() => {
    // Add number
    if (data !== null) {
      const pageBefore = pageSize * (pageNo - 1);
      const initData = data.map((item, index) => {
        return {
          ...item,
          no: index + 1 + pageBefore,
        };
      });
      setTableData(initData);
    }
  }, [data, pageSize, pageNo]);

  const handleSearch = async () => {
    let params = {};
    fields.forEach((item) => {
      params[item.params] = item.value;
    });
    params.is_enable = "Y";
    params.pageNo = 1;
    params.pageSize = paginationSet;

    try {
      const response = await dispatch(fetchClient(params));
      if (response.payload.data.status === 200) {
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleTableChange = async (
    type,
    { page, sizePerPage, sortField, sortOrder, data }
  ) => {
    if (type === "pagination") {
      let params = {};
      fields.forEach((item) => {
        params[item.params] = item.value;
      });

      params.is_enable = "Y";
      params.pageNo = page;
      params.pageSize = sizePerPage;
      try {
        const response = await dispatch(fetchClient(params));
        if (response.payload.data.status === 200) {
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    } else {
      let result;
      if (sortOrder === "asc") {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return 1;
          } else if (b[sortField] > a[sortField]) {
            return -1;
          }
          return 0;
        });
      } else {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return -1;
          } else if (b[sortField] > a[sortField]) {
            return 1;
          }
          return 0;
        });
      }
    }
  };
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };

  // params

  const [typeOptions, setTypeOptions] = useState([
    {
      id: "1",
      value: "client_code",
      label: "Code",
      show: "Y",
      editor: "text",
    },
    {
      id: "2",
      value: "client_name",
      label: "Name",
      show: "Y",
      editor: "text",
    },
  ]);

  // paket filter

  const [btnHide, setBtnHide] = useState(false);

  const data_filter = typeOptions.filter((element) => element.show === "Y");

  function handleRemarkChange(i, event) {
    const values = [...fields];
    values[i].value = event.target.value;
    setFields(values);
    return true
  }

  function handleAdd(i, event) {
    const values = [...fields];

    if (values[i].params === "") {
      showDialog("Please select filter first");
    } else {
      // update disabled field
      values[i].add = "Y";
      values[i].remove = "Y";
      setFields(values);
      //   change status show

      const result = typeOptions.map((item) => {
        if (item.value === values[i].params) {
          return { ...item, show: "N" };
        }
        return item;
      });

      setTypeOptions(result);

      const filteredShow = result.filter((item) => item.show === "Y");
      if (filteredShow.length <= 1) {
        setBtnHide(true);
      } else {
        setBtnHide(false);
      }

      //   push new paramater
      values.push({
        id: "",
        value: "",
        params: "",
        label: "",
        add: "N",
        editor: "text",
        remove: "N",
      });
      setFields(values);
      return true
    }
  }

  function handleRemove(i) {
    const values = [...fields];

    const result = typeOptions.map((item) => {
      if (item.value === values[i].params) {
        return { ...item, show: "Y" };
      }
      return item;
    });

    setTypeOptions(result);

    const filteredShow = result.filter((item) => item.show === "Y");
    if (filteredShow.length >= 1) {
      setBtnHide(false);
    } else {
      setBtnHide(true);
    }

    values.splice(i, 1);
    setFields(values);
    return true
  }

  const handleTypeChange = (i, event) => {
    const values = [...fields];
    values[i].params = event.value;
    values[i].id = event.id;
    values[i].editor = event.editor;
    values[i].label = event.label;
    setFields(values);
    return true
  };

  // paket filter bawah

  const columns = [
    {
      text: "Code",
      dataField: "client_code",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
    {
      text: "Name",
      dataField: "client_name",

      style: { minWidth: "60px" },
      headerAlign: "center",
    },
  ];

  const options = {
    page: pageNo,
    sizePerPage: pageSize,
    showTotal: true,
    totalSize: totalRecord,
    sizePerPageList: sizePerPageList,
  };

  const handleClose = () => {
    setSelected(null);
    setShow(false);
    setFields([
      {
        id: "",
        value: "",
        params: "",
        label: "",
        add: "N",
        editor: "text",
        remove: "N",
      },
    ]);
  };

  const selectRow = {
    mode: "radio",
    clickToSelect: true,
    onSelect: (row, isSelect, rowIndex, e) => {
      setSelected(row);
    },
  };

  const handleSave = (e) => {
    if (selected === null) {
      return showDialog("Please select first !");
    }
    const value = selected.client_name;
    setFormValues({
      ...formValues,
      ["client"]: {
        ...formValues["client"],
        value,
      },
    });
    handleClose();
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Modal
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={isOpen}
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter text-white">
            Search Client
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {fields.map((field, idx) => {
            return (
              <div key={`${field}-${idx}`}>
                <Form.Group as={Row}>
                  <Form.Label column sm={1}>
                    {idx === 0 && <b>Search By</b>}
                  </Form.Label>

                  <Col sm={3}>
                    {fields[idx].add === "N" && (
                      <Select
                        // isClearable={true}
                        options={data_filter}
                        value={getValueType(field.params, typeOptions)}
                        placeholder="Select Field"
                        // onChange={handleTypeChange}
                        onChange={(e) => handleTypeChange(idx, e)}
                      />
                    )}
                    {fields[idx].add === "Y" && (
                      <Form.Control
                        type="text"
                        value={fields[idx].label}
                        disabled
                      />
                    )}
                  </Col>
                  <Col sm={3}>
                    {field.editor === "text" && (
                      <Form.Control
                        type="text"
                        placeholder="Enter text"
                        value={field.value || ""}
                        onChange={(e) => handleRemarkChange(idx, e)}
                      />
                    )}
                  </Col>
                  <Col sm={3} className=" m-0 p-0">
                    {fields[idx].remove === "Y" && (
                      <div
                        className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                        onClick={() => handleRemove(idx)}
                      >
                        <span className="svg-icon svg-icon-md svg-icon-light">
                          <SVG
                            src={toAbsoluteUrl("/media/svg/icons/New/X.svg")}
                          />
                        </span>
                      </div>
                    )}

                    {btnHide === false && fields.length - 1 === idx && (
                      <Button
                        className="mr-3"
                        variant="outline-primary"
                        onClick={(e) => handleAdd(idx, e)}
                      >
                        Add
                      </Button>
                    )}

                    {fields.length - 1 === idx && (
                      <Button
                        className="mr-3"
                        variant="primary"
                        onClick={handleSearch}
                      >
                        Search
                      </Button>
                    )}
                  </Col>
                </Form.Group>
              </div>
            );
          })}

          {data && data.length > 0 && (
            <BootstrapTable
              remote
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              
              keyField="client_id"
              data={tableData}
              columns={columns}
              pagination={paginationFactory(options)}
              onTableChange={handleTableChange}
              selectRow={selectRow}
              hover
            >
              <PleaseWaitMessage entities={loading ? null : data} />
              <NoRecordsFoundMessage entities={loading ? null : data} />
            </BootstrapTable>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSave}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
